// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3z9qc","insightsList":"newBusinessInsightsMenu_insightsList__18M9i","active":"newBusinessInsightsMenu_active__iOmk3"};